module.exports = __webpack_public_path__ + "images/fa-business-group-waving.webp";